<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
// import EditButtonsBottomContent from '@nuxtDatakodeUtils/components/i3p/panels/editButtonsBottom/Content.vue'

import EditButtonsBottomContent from '@nuxtDatakodeUtils/components/i3p/panels/editButtonsBottom/Content.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'

export default {
    name: 'TopButtons',
    components: { EditButtonsBottomContent },
    extends: i3pSubComponent,
    props: {},
    // component: { EditButtonsBottomContent },
    data() {
        return {
            modelPermissionName: null,
        }
    },
    computed: {
        BaseRoutesEnum() {
            return BaseRoutesEnum
        },
        model() {
            return this.i3pService.getModel()
        },
        responsiveClass() {
            return this.$vuetify.display.mdAndDown ? 'mb-2' : ''
        },
    },
    mounted() {
        this.modelPermissionName = this.i3pService.getModel().permissionName
    },
    methods: {
        createEntity() {
            this.i3pService.createEntity().then(() => {
                this.i3pService.setEditMode(true)
            })
        },
    },
}
</script>

<template>
    <div v-if="i3pService.editMode">
        <EditButtonsBottomContent :i3p-service />
    </div>
    <div v-else>
        <template v-if="baseUrl === BaseRoutesEnum.myIntentions">
            <!--            <v-btn v-if="i3pService?.currentEntity && $permissionCheck(`${i3pService.currentEntity.permissionName}_store`)" class="mr-2" :class="responsiveClass" variant="flat" prepend-icon="mdi-plus" size="small" color="primary" @click="createEntity"> -->
            <v-btn v-if="$permissionCheck(`${modelPermissionName}_store`)" class="mr-2" :class="responsiveClass" variant="flat" prepend-icon="mdi-plus" size="small" color="primary" @click="createEntity">
                Ajouter une intention
            </v-btn>

            <v-btn
                v-if="$permissionCheck(`voirie_intentionsImport_create`)"
                class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-file-import" size="small" color="primary"
                href="./intentions-import"
                @click.prevent="$router.push('/mes-intentions/intentions-import')"
            >
                Importer
            </v-btn>
        </template>

        <v-btn
            v-if="[BaseRoutesEnum.myIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-check-circle" size="small" color="primary"
            :href="BaseRoutesEnum.myArchivedIntentions" @click.prevent="$router.push(BaseRoutesEnum.myArchivedIntentions)"
        >
            Voir mes intentions réalisées ou abandonnées
        </v-btn>
        <v-btn
            v-if="[BaseRoutesEnum.allIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-check-circle" size="small" color="primary"
            :href="BaseRoutesEnum.allArchivedIntentions" @click.prevent="$router.push(BaseRoutesEnum.allArchivedIntentions)"
        >
            Voir toutes les intentions réalisées ou abandonnées
        </v-btn>
        <v-btn
            v-if="[BaseRoutesEnum.myArchivedIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-dots-circle" size="small" color="primary"
            :href="BaseRoutesEnum.myIntentions" @click.prevent="$router.push(BaseRoutesEnum.myIntentions)"
        >
            Voir mes intentions en cours
        </v-btn>
        <v-btn
            v-if="[BaseRoutesEnum.allArchivedIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-dots-circle" size="small" color="primary"
            :href="BaseRoutesEnum.allIntentions" @click.prevent="$router.push(BaseRoutesEnum.allIntentions)"
        >
            Voir toutes les intentions en cours
        </v-btn>
        <v-btn
            v-if="[BaseRoutesEnum.allArchivedIntentions, BaseRoutesEnum.allIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-format-list-bulleted-square" size="small" color="primary"
            :href="BaseRoutesEnum.myIntentions" @click.prevent="$router.push(BaseRoutesEnum.myIntentions)"
        >
            Voir mes intentions
        </v-btn>
        <v-btn
            v-if="[BaseRoutesEnum.myArchivedIntentions, BaseRoutesEnum.myIntentions].includes(baseUrl)"
            class="mr-2" :class="responsiveClass" variant="outlined" prepend-icon="mdi-format-list-bulleted-square" size="small" color="primary"
            :href="BaseRoutesEnum.allIntentions" @click.prevent="$router.push(BaseRoutesEnum.allIntentions)"
        >
            Voir toutes les intentions
        </v-btn>
    </div>
</template>
